{
    "up.common.cancel": "Abbrechen",
    "up.common.confirm": "Bestätigen",
    "up.common.start": "Start",
    "up.common.end": "Ende",
    "up.common.stop": "Stopp",
    "up.common.copy": "Kopieren",
    "up.common.none": "Keine",
    "up.common.tip": "Hinweis",
    "up.common.success": "Erfolg",
    "up.common.fail": "Fehlgeschlagen",
    "up.common.close": "Schließen",
    "up.common.preview": "Vorschau",
    "up.common.re-select": "Erneut auswählen",
    "up.common.rotate": "Drehen",
    "up.common.pleaseChoose": "Bitte wählen",
    "up.common.loading": "Laden",
    "up.common.loading2": "Wird geladen",
    "up.common.inOperation": "In Bearbeitung",
    "up.common.settings": "Einstellungen",
    "up.common.retry": "Wiederholen",
    "up.common.search": "Suchen",
    "up.common.more": "Mehr",
    "up.common.video": "Video",
    "up.common.file": "Datei",
    "up.week.one": "Mo",
    "up.week.two": "Di",
    "up.week.three": "Mi",
    "up.week.four": "Do",
    "up.week.five": "Fr",
    "up.week.six": "Sa",
    "up.week.seven": "So",
    "up.barcode.error": "Barcode-Generierung fehlgeschlagen",
    "up.calendar.chooseDates": "Datumsauswahl",
    "up.calendar.disabled": "Dieses Datum ist deaktiviert",
    "up.calendar.daysExceed": "Die Anzahl der ausgewählten Tage darf {days} Tage nicht überschreiten",
    "up.cityLocate.locateCity": "Stadt lokalisieren",
    "up.cityLocate.fail": "Lokalisierung fehlgeschlagen, bitte klicken Sie zum Wiederholen.",
    "up.cityLocate.locating": "Lokalisierung läuft",
    "up.code.send": "Bestätigungscode erhalten",
    "up.code.resendAfter": "Erneut senden in X Sekunden",
    "up.code.resend": "Erneut senden",
    "up.cropper.emptyWidhtOrHeight": "Breite oder Höhe des Zuschneidebereichs nicht festgelegt",
    "up.empty.car": "Warenkorb ist leer",
    "up.empty.page": "Seite existiert nicht",
    "up.empty.search": "Keine Suchergebnisse",
    "up.empty.address": "Keine Lieferadresse",
    "up.empty.wifi": "Kein WLAN",
    "up.empty.order": "Bestellungen sind leer",
    "up.empty.coupon": "Keine Gutscheine",
    "up.empty.favor": "Keine Favoriten",
    "up.empty.permission": "Keine Berechtigung",
    "up.empty.history": "Kein Verlauf",
    "up.empty.news": "Keine Nachrichtenliste",
    "up.empty.message": "Nachrichtenliste ist leer",
    "up.empty.list": "Liste ist leer",
    "up.empty.data": "Daten sind leer",
    "up.empty.comment": "Keine Kommentare",
    "up.link.copyed": "Link kopiert, bitte im Browser öffnen",
    "up.loadmoe.loadmore": "Mehr laden",
    "up.loadmoe.nomore": "Keine weiteren Daten",
    "up.noNetwork.text": "Ups, Netzwerksignal verloren",
    "up.noNetwork.pleaseCheck": "Bitte überprüfen Sie das Netzwerk oder gehen Sie zu",
    "up.noNetwork.connect": "Netzwerk verbunden",
    "up.noNetwork.disconnect": "Keine Netzwerkverbindung",
    "up.pagination.previous": "Vorherige Seite",
    "up.pagination.next": "Nächste Seite",
    "up.pullRefresh.pull": "Zum Aktualisieren nach unten ziehen",
    "up.pullRefresh.release": "Loslassen zum Aktualisieren",
    "up.pullRefresh.refreshing": "Aktualisierung läuft",
    "up.readMore.expand": "Erweitern zum vollständigen Lesen",
    "up.readMore.fold": "Einklappen",
    "up.search.placeholder": "Bitte Schlüsselwort eingeben",
    "up.signature.penSize": "Strichstärke",
    "up.signature.penColor": "Strichfarbe",
    "up.upload.sizeExceed": "Größenbegrenzung überschritten",
    "up.upload.uploading": "Upload läuft",
    "up.upload.previewImageFail": "Bildvorschau fehlgeschlagen",
    "up.upload.previewVideoFail": "Videovorschau fehlgeschlagen",
    "up.goodsSku.stock": "Lagerbestand",
    "up.goodsSku.price": "Preis",
    "up.goodsSku.amount": "Stück",
    "up.goodsSku.choosed": "Ausgewählt",
    "up.goodsSku.buyAmount": "Anzahl"
}
